import type { VoidFunctionComponent } from 'react';

import { Icon, icons } from '../../generic/Icon';
import { ICON_SIZE } from '../../generic/Icon/icon-constants';

import styles from './IssueComparison.module.less';

const EmptyState: VoidFunctionComponent = () => {
  return (
    <div className={styles.emptyStateContainer}>
      <span className={styles.imageContainer}>
        <Icon icon={icons.codeCompare} size={ICON_SIZE.XXL} />
      </span>
      <div className={styles.mainText}>
        Compare changes across revisions
      </div>
      <div className={styles.subText}>
        Select a revision above so you can see which issues are new, remediated, or unchanged.
      </div>
    </div>
  );
};

export default EmptyState;
